import httpManager from "@/app/shared/utils/httpManager";

export async function fetchTemplateTierLimit(channelCustomerId) {
  const response = await httpManager.get(
    `/channels/channel-customer/${channelCustomerId}/tier-limit`
  );

  return response?.data?.tier_limit;
}
